export default "__VITE_ASSET__D$FI4eOJ__"